// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-chat-view {
  height: 100%;
  width: 100%;
}

.new-chat-top-bar-container {
  height: 74px;
  width: 100%;
}

.new-chat-content {
  height: calc(100% - 74px);
  width: 100%;
  display: flex;
  flex-direction: row;
}

.new-chat-messages-container {
  height: 100%;
  width: calc(100% - 320px);
}

.new-chat-contacts-container {
  height: 100%;
  width: 320px;
}

.new-chat-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: #666;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/NewChatView.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;AACjB","sourcesContent":[".new-chat-view {\n  height: 100%;\n  width: 100%;\n}\n\n.new-chat-top-bar-container {\n  height: 74px;\n  width: 100%;\n}\n\n.new-chat-content {\n  height: calc(100% - 74px);\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n}\n\n.new-chat-messages-container {\n  height: 100%;\n  width: calc(100% - 320px);\n}\n\n.new-chat-contacts-container {\n  height: 100%;\n  width: 320px;\n}\n\n.new-chat-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  color: #666;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
